import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
  STREVDA_SLOTS,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import keyBy from 'lodash/keyBy';

import {
  getAdvertsFromRadarResponse,
  mapStrevdaSlotsToAdvertState,
} from '../../../adverts/helpers/transformAdverts/index';

import type {
  Advert,
  AdvertById,
  AdvertState,
  Creative,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';
import type {
  Action,
  MutationResponseAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { ID } from '@web-platform/shared-universal-types-utils/src/utils';

export const INITIAL_STATE = {
  byId: {},
};

const generateNewState = (state: AdvertById, adverts: Advert[]): AdvertById => {
  const newAdvertsById: AdvertById = keyBy(adverts, (advert) => advert.id);
  const combinedAdvertsById = { ...state, ...newAdvertsById };
  return combinedAdvertsById;
};

const byId = (state: AdvertById, action: MutationResponseAction | QueryResponseAction) => {
  switch (action.payload.type) {
    case RADAR_CREATE_SESSIONS:
    case RADAR_POLL: {
      const adverts = getAdvertsFromRadarResponse(action);
      if (adverts === null) {
        return state;
      }
      return generateNewState(state, adverts);
    }

    case STREVDA_SLOTS: {
      if (action.payload.response.error) {
        return state;
      }

      const adverts = mapStrevdaSlotsToAdvertState(action.payload.response);
      return generateNewState(state, adverts);
    }

    default:
      return state;
  }
};

const advertReducer = (state: AdvertState = INITIAL_STATE, action: Action): AdvertState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export default advertReducer;
export const all = (state: AdvertState) => state.byId;
export const get = <C extends Creative>(state: AdvertState, id: ID) =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  state.byId[id] as Advert & { creative: C };
